import { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box, Stack
} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const emptyForm = { docType: '', summary: '', involvedParties: '', keyAmount: '', keyDate: '', notes: '' };

// Formulario opcional que se muestra justo después de subir un documento.
// Lo que se llena aquí queda en document_metadata y es lo que el copiloto
// IA consulta primero (search_documents) antes de leer el archivo completo,
// para reducir costos.
const DocumentMetadataModal = ({ open, documentName, saving = false, onSave, onSkip }) => {
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    if (open) setForm(emptyForm);
  }, [open]);

  const handleChange = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  return (
    <Dialog open={open} onClose={saving ? undefined : onSkip} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AutoAwesomeIcon fontSize="small" color="primary" />
        Datos del documento (opcional)
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {documentName ? `"${documentName}" — ` : ''}
          Completa lo que sepas para que el copiloto IA pueda responder preguntas sobre este documento sin tener que leerlo completo. Puedes omitirlo.
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="Tipo de documento"
            placeholder="Ej. Contrato, Identificación, Factura…"
            fullWidth
            value={form.docType}
            onChange={handleChange('docType')}
            disabled={saving}
          />
          <TextField
            label="Resumen"
            placeholder="De qué trata el documento"
            fullWidth
            multiline
            minRows={2}
            value={form.summary}
            onChange={handleChange('summary')}
            disabled={saving}
          />
          <TextField
            label="Partes involucradas"
            placeholder="Nombres de personas o empresas mencionadas"
            fullWidth
            value={form.involvedParties}
            onChange={handleChange('involvedParties')}
            disabled={saving}
          />
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Monto clave"
              type="number"
              fullWidth
              value={form.keyAmount}
              onChange={handleChange('keyAmount')}
              disabled={saving}
            />
            <TextField
              label="Fecha clave"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={form.keyDate}
              onChange={handleChange('keyDate')}
              disabled={saving}
            />
          </Box>
          <TextField
            label="Notas"
            fullWidth
            multiline
            minRows={2}
            value={form.notes}
            onChange={handleChange('notes')}
            disabled={saving}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onSkip} disabled={saving}>Omitir</Button>
        <Button onClick={() => onSave(form)} variant="contained" disabled={saving}>
          {saving ? 'Guardando…' : 'Guardar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentMetadataModal;
